export enum ELocalizationLang {
  EN = "en",
  AR = "ar",
}
